import { Component, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { ClientsSocisService } from '../services/clients_socis/clientsSocis.service';
import { DialogClientsSocis } from '../dialog/clientssocis/dialog.component.clientssocis';

import { MatDialog, MatDialogRef } from '@angular/material/dialog'

import { ListClientsSocisService } from './list.service';
import { AuthUserService } from '../services/auth-user-service/auth-user.service';
import { saveAs } from 'file-saver';

import { IClientsSocis, IClientsSocisResponse } from './clientssocis.interfaces';

import { MatSidenav } from '@angular/material/sidenav';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-clientssocis',
  templateUrl: './clientssocis.component.html',
  styleUrls: ['./clientssocis.component.scss'],
  providers: [ClientsSocisService, ListClientsSocisService, AuthUserService]
})
export class ClientsSocisComponent implements OnInit, OnDestroy {
  public showAsyncProgress: boolean = false;
  public clientsSocisData: IClientsSocisResponse;
  private unsubscriber : Subject<void> = new Subject<void>();
  private currentOrdering: any = {};
  private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number = 0;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  public showFilters: boolean = true;
  public orderingParameters: any;
  public export: boolean = false;
  private clientSociModel: IClientsSocis = {
      'id': 'NEW',
      'nom': null,
      'tipus': null,
      'telefon': null,
      'adreca': null,
      'client': true,
      'soci': true,
      'localitzacio': null,
      'descripcio': null,
      'comentari': null,
      'web': null,
      'mail': null,
      'country': null,
      'cif': null
  };
  private id: string;
  public error: string = '';
  public showDialog: boolean = false;
  public editClientSociData: IClientsSocis;

  public exportar(){this.export=true;this.requestRowsToParent();};

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  public addClientSoci(): void {
    this.editClientSociData = Object.assign(
      {},
      this.clientSociModel,
      { id : 'NEW' }
    );
    let dialogFactRef=this.dialog.open(DialogClientsSocis, {disableClose: true, height: '620px', data: this.editClientSociData })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editClientSociData = results;
      this.addOrUpdate();
    });
    //this.showDialog = true;
  }

  public editClientSoci(clientSoci: IClientsSocis): void {
    this.editClientSociData = Object.assign(
      {},
      this.clientSociModel,
      clientSoci
    );
    let dialogFactRef=this.dialog.open(DialogClientsSocis, {disableClose: true, height: '620px', width: '1000px', data: this.editClientSociData })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editClientSociData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;
    if (this.editClientSociData.id === 'NEW') {
      this.clientsSocisService.createClientSoci(this.editClientSociData)
        .subscribe(newClientSoci => {console.log("S'ha creat l'element");window.location.reload();});
    } else {
      this.clientsSocisService.updateClientSoci(<number> this.editClientSociData.id, this.editClientSociData)
        .subscribe(updatedClientSoci => {console.log("S'han desat les dades");
          //Actualitza la llista amb les modificacions
          let updateItem = this.clientsSocisData.rows.find(item => item.id == this.editClientSociData.id);
          let index = this.clientsSocisData.rows.indexOf(updateItem);
          this.clientsSocisData.rows[index] = this.editClientSociData;
        });
    };
  }

  public deleteClientSoci(event, IdclientSociToDelete: number): void {
    event.stopPropagation();
    event.preventDefault();
    if(confirm("Confirma l'esborrat del client/soci")){
      this.showAsyncProgress = true;
      this.clientsSocisService.deleteClientSoci(<number> IdclientSociToDelete)
        .subscribe(deletedClientSoci => {
          this.showAsyncProgress = false;
          if(deletedClientSoci.err){this.error = deletedClientSoci.err;return;}
          console.log("S'ha esborrat l'element");window.location.reload();
        });
    }
  }

  public gotoPage(page: number): void {
    this.listClientsSocisService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
  }

  public computeActiveFilters($event){
    this.listClientsSocisService.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listClientsSocisService.currentPage * this.listClientsSocisService.rowsPerPage;
    this.requestRowsToParent();
   }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

   private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listClientsSocisService.currentPage * this.listClientsSocisService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listClientsSocisService.rowsPerPage - 1, this.clientsSocisData.registers);
   }

   private requestRowsToParent(): void {
      this.clientsSocisService.getList(
        this.listClientsSocisService.rowsPerPage, //Limit
        (this.firstRegisterShown?this.firstRegisterShown:1) - 1, //Skip
        this.listClientsSocisService.activeFilters //FILTRE DELS REGISTRES QUE ES MOSTREN A INICI
        ,{}//Conds a aplicar. Per defecte LIKE %%
        ,this.currentOrdering //ORDRE DELS TREBALLS QUE ES MOSTREN A INICI (tematica3, data_aprovacio)
      ).subscribe(
        data => {
          if(!this.export){this.clientsSocisData = data;this.computeDisplayedRows();}
          else{
            var csvData = this.convertToCSV(data.rows);
            var file = new Blob(["\ufeff",csvData], { type: 'text/csv;charset=utf-8' });
            saveAs(file, "export.csv");
          }
        },
        error => console.log(error)
      );
   }

   public requestPrevious(): void {
     this.listClientsSocisService.currentPage = Math.max(0, this.listClientsSocisService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
   }

   public requestNext(): void {
     this.listClientsSocisService.currentPage = this.listClientsSocisService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
   }

   public setRowPerPage(rowsPerPage: number) {
     this.listClientsSocisService.rowsPerPage = rowsPerPage;
     this.requestRowsToParent();
   }

  public clientsSocisFilters: Array<any>
  public ordreCamps: Array<any>
  public tableFields: Array<any>

  constructor(public translate: TranslateService, public languageService: LanguageService, public listClientsSocisService: ListClientsSocisService, public dialog:MatDialog, private clientsSocisService: ClientsSocisService, private AuthUserService: AuthUserService, private router: Router) { }

ngOnInit() {
  this.ordreCamps = ['id'];

  this.buildStaticData();

  // Si l'usuari canvia d'idioma en calent, reconstruïm els textos
  this.translate.onLangChange
    .pipe(takeUntil(this.unsubscriber))
    .subscribe(() => this.buildStaticData());

  this.orderingParameters = this.tableFields.reduce((acum, curr) => {
    acum[curr[0]] = 0;
    return acum;
  }, {});

  ['id'].map(item => this.currentOrdering[item] = this.orderingCycle[2]);
  this.computeActiveFilters({});

  history.pushState(null, document.title, location.href);

  fromEvent(window, 'popstate').pipe(
    takeUntil(this.unsubscriber)
  ).subscribe((_) => {
    history.pushState(null, '');
  });
}

private buildStaticData() {
  this.tableFields = [
    ['nom', this.translate.instant('clientsSocisList.colEmpresa')],
    ['tipus', this.translate.instant('clientsSocisList.colTipus')],
    ['localitzacio', this.translate.instant('clientsSocisList.colLocalitzacio')],
    ['country', this.translate.instant('clientsSocisList.colPais')]
  ];

  this.clientsSocisFilters = [
    {
      inputs: [
        {
          name: this.translate.instant('clientsSocisList.filtreGrupTipus'),
          type: 'checkbox',
          values: [
            {
              text: this.translate.instant('clientsSocisList.chkClients'),
              name: 'client',
              value: true
            },
            {
              text: this.translate.instant('clientsSocisList.chkSocis'),
              name: 'soci',
              value: true
            }
          ]
        }
      ]
    },
    {
      inputs: [
        {
          name: 'text',
          type: 'text',
          values: [
            {
              text: this.translate.instant('clientsSocisList.colEmpresa'),
              name: 'nom',
              autocomplete: 'clientsSocis',
              value: this.listClientsSocisService.getSearchValues('nom')
            },
            {
              text: this.translate.instant('clientsSocisList.colTipus'),
              name: 'tipus',
              autocomplete: 'tipusCliSoc',
              value: this.listClientsSocisService.getSearchValues('tipus')
            },
            {
              text: this.translate.instant('clientsSocisList.colLocalitzacio'),
              name: 'localitzacio',
              autocomplete: 'locCliSoc',
              value: this.listClientsSocisService.getSearchValues('localitzacio')
            },
            {
              text: this.translate.instant('clientsSocisList.colPais'),
              name: 'country',
              autocomplete: 'countryCliSoc',
              value: this.listClientsSocisService.getSearchValues('country')
            }
          ]
        }
      ]
    }
  ];
  console.log(this.clientsSocisFilters);

}

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

}
